import {observable, action} from 'mobx';
import {TechseeBaseController} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-controller';

export class ClientTimeoutDialogController extends TechseeBaseController {
    @observable isVisible: boolean = false;

    @action
    show() {
        this.isVisible = true;
    }

    @action
    hide() {
        this.isVisible = false;
    }

    @action
    closeMessage() {
        this.hide();
        this.emit('close');
    }
}
